// Test IDs for Umami Kraft
export const NAV = {
    logo: "nav-logo",
    home: "nav-home",
    menu: "nav-menu",
    specials: "nav-specials",
    about: "nav-about",
    contact: "nav-contact",
    cartBtn: "nav-cart-btn",
    cartCount: "nav-cart-count",
    mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
    orderBtn: "hero-order-btn",
    menuBtn: "hero-menu-btn",
    dailySpecialsBtn: "hero-daily-specials-btn",
};

export const MENU = {
    categoryPrefix: "menu-cat-",
    itemPrefix: "menu-item-",
    addBtnPrefix: "menu-add-btn-",
    searchInput: "menu-search-input",
};

export const CART = {
    drawer: "cart-drawer",
    linePrefix: "cart-line-",
    incPrefix: "cart-inc-",
    decPrefix: "cart-dec-",
    removePrefix: "cart-remove-",
    checkoutBtn: "cart-checkout-btn",
    clearBtn: "cart-clear-btn",
    empty: "cart-empty",
};

export const CHECKOUT = {
    name: "checkout-name",
    email: "checkout-email",
    phone: "checkout-phone",
    notes: "checkout-notes",
    payfast: "checkout-payfast",
    cash: "checkout-cash",
    submit: "checkout-submit",
};

export const MODIFIER = {
    dialog: "modifier-dialog",
    addBtn: "modifier-add-btn",
    optionPrefix: "modifier-option-",
};

export const CONTACT = {
    form: "contact-form",
    name: "contact-name",
    email: "contact-email",
    phone: "contact-phone",
    message: "contact-message",
    submit: "contact-submit",
    whatsapp: "contact-whatsapp",
    call: "contact-call",
};

export const ADMIN = {
    email: "admin-email",
    password: "admin-password",
    loginBtn: "admin-login-btn",
    logout: "admin-logout",
    ordersTab: "admin-orders-tab",
    menuTab: "admin-menu-tab",
    settingsTab: "admin-settings-tab",
    orderPrefix: "admin-order-",
    itemAvailPrefix: "admin-item-avail-",
    itemPricePrefix: "admin-item-price-",
    itemSavePrefix: "admin-item-save-",
    tradingHours: "admin-trading-hours",
    prepTime: "admin-prep-time",
    accepting: "admin-accepting",
    saveSettings: "admin-save-settings",
};

export const WHATSAPP = { float: "whatsapp-float" };
